import { Link, useLocation } from 'react-router-dom';
import { buildTenantPath, extractTenantSlugFromPathname } from '../utils/tenantSlug';

const AccessDeniedPage = () => {
  const location = useLocation();
  const tenantSlug = extractTenantSlugFromPathname(location.pathname);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
      <h1 className="text-6xl font-bold text-primary-600">403</h1>
      <h2 className="mt-4 text-2xl font-semibold text-gray-800">Acesso Negado</h2>
      <p className="mt-2 text-gray-600">
        Você não tem permissão para visualizar esta página.
      </p>
      <div className="mt-6">
        <Link
          to={buildTenantPath("/", tenantSlug)}
          className="px-6 py-3 bg-primary-600 text-white font-semibold rounded-md hover:bg-primary-700 transition-colors"
        >
          Voltar para a Página Inicial
        </Link>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
